<template>
  <div class="entry responsive content">
    <!-- 80:110 -->
    <Head />
    <div class="clearfix fix-content">
      <div class="fixed left">
        <el-menu default-active="1" @open="handleOpen" @close="handleClose" @select="handleSelect">
          <el-menu-item index="1">
            <span slot="title">{{ tempData.baseInfo.title }}</span>
          </el-menu-item>
          <el-submenu index="2">
            <template slot="title">
              <span slot="title">{{ tempData.personEducations.title }}</span>
            </template>
            <el-menu-item v-for="item in personEducations.list" :key="item.index" :index="item.index">
              <span slot="title">{{item.schoolName}}</span>
            </el-menu-item>
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">
              <span slot="title">{{ tempData.personWorkExperiences.title }}</span>
            </template>
            <el-submenu v-for="item in personWorkExperiences.list" :key="item.index" :index="item.index">
              <span slot="title">{{item.companyName}}</span>
              <el-menu-item v-for="ele in item.personProjectExperiences" :key="ele.index" :index="ele.index">{{ele.projectName}}</el-menu-item>
            </el-submenu>
          </el-submenu>
          <el-submenu index="4">
            <template slot="title">
              <span slot="title">{{ tempData.personSkills.title }}</span>
            </template>
            <el-menu-item v-for="item in personSkills.list" :key="item.index" :index="item.index">
              <span slot="title">{{item.skillTitle}}</span>
            </el-menu-item>
          </el-submenu>
          <el-submenu index="5">
            <template slot="title">
              <span slot="title">{{ tempData.personHonors.title }}</span>
            </template>
            <el-menu-item v-for="item in personHonors.list" :key="item.index" :index="item.index">
              <span slot="title">{{item.honorName}}</span>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
      <div class="right menu-box" :class="{'is-loading': isLoading}" v-loading="isLoading">
        <!-- baseInfo -->
        <el-card class="t-baseInfo">
          <p class="menu-title">{{ tempData.baseInfo.title }}</p>
          <p ref="baseInfo" class="menu-ref menu-ref-baseInfo"></p>
          <el-upload class="avatar-uploader" :class="{'avatar-view': !baseInfo.isEdit}" drag
                     action="https://leo2vip.top/bigboss-feign/uploadWeb/uploadPic/test"
                     :with-credentials="true" :show-file-list="false" :on-success="handleAvatarSuccess"
                     :before-upload="beforeAvatarUpload" :disabled="!baseInfo.isEdit">
            <img v-if="baseInfo.imageUrl" :src="baseInfo.imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <el-form :model="baseInfo" :inline="true" label-width="100px" v-if="baseInfo.isEdit" class="m-t-10">
            <el-form-item :label="item.title" v-for="(item,index) in baseInfo.items" :key="index" v-if="item.type">
              <div v-if="item.type == 'text' || item.type == 'number'">
                <el-input :type="item.type" v-model="item.val" :placeholder="'请填写' + item.title"></el-input>
              </div>
              <div v-else-if="item.type == 'radio'">
                <el-radio-group v-model="item.val">
                  <el-radio v-for="(k,v,index) in item.list" :key="index" :label="v">{{k.title}}</el-radio>
                </el-radio-group>
              </div>
              <div v-else-if="item.type == 'picker'">
                <el-date-picker type="date" :placeholder="'请选择' + item.title" v-model="item.val" value-format="yyyy-MM-dd"></el-date-picker>
              </div>
              <div v-else-if="item.type == 'select'">
                <el-select v-model="item.val" :placeholder="'请选择' + item.title">
                  <el-option v-for="(val,key,index) in item.list" :key="index" :label="val.title" :value="key"></el-option>
                </el-select>
              </div>
              <div v-else-if="item.type == 'textarea'">
                <el-input type="textarea" :rows="8" v-model="item.val" :placeholder="'请填写' + item.title"></el-input>
              </div>
            </el-form-item>
          </el-form>
          <div v-else class="p-16 baseInfo-item" @click="editBtn('baseInfo')">
            <el-button type="text" class="edit-btn right">
              <i class="el-icon-edit-outline"></i>编辑
            </el-button>
            <div v-for="(item,index) in baseInfo.items" :key="index" v-if="item.type" class="item" :class="{'w-1': item.type == 'textarea'}">
              <span class="bold i-block" :class="{'l-30 top': item.val && item.type == 'textarea'}">{{item.title}}:</span>
              <span class="i-block" :class="{'t-baseInfo-introduce l-30': item.type == 'textarea'}">
                <span v-if="item.type == 'picker'">{{ item.val|formatDate("yyyy-MM-dd") || '-' }}</span>
                <span v-else-if="item.type == 'textarea'" class="l-30 pre-line">{{ item.val || '-' }}</span>
                <span v-else-if="item.type == 'select'">
                  {{item.val == '-1' ? '-' : (item.list ? item.list[item.val] && item.list[item.val].title : item.val)}}
                </span>
                <span v-else>
                  {{(item.list ? item.list[item.val] && item.list[item.val].title : item.val) || '-'}}
                </span>
              </span>
            </div>
          </div>
          <div class="center" v-if="baseInfo.isEdit">
            <el-button round size="medium" @click="closeBtn('baseInfo')">取消</el-button>
            <el-button type="primary" round size="medium" @click="handleBaseInfo">{{resumeId ? '更新' : '保存'}}</el-button>
          </div>
        </el-card>
        <!-- education -->
        <el-card class="t-education b-education" v-show="resumeId">
          <p class="menu-title">{{ tempData.personEducations.title }}</p>
          <p ref="personEducations" class="menu-ref"></p>
          <div v-for="(item,index) in personEducations.list" :key="index" class="item p-16 clearfix">
            <p :ref="item.index" class="menu-ref"></p>
            <div v-if="!item.isEdit" @click="editBtn('personEducations', item)">
              <span class="bold e-title i-block">{{item.schoolName}}</span>
              <span class="m-l-10">{{item.educationStartDate|formatDate("yyyy-MM")}} - {{item.educationEndDate|formatDate("yyyy-MM")}}</span>
              <el-button type="text" class="edit-btn right m-l-10">
                <i class="el-icon-edit-outline"></i>编辑
              </el-button>
              <el-button type="text" class="edit-btn gray right" @click.stop="delBtn('personEducations', item, index)">
                <i class="el-icon-edit-outline"></i>删除
              </el-button>
              <el-row class="l-30">
                <el-col :span="12" class="omit">
                  <span class="bold">专业: </span>{{item.majorName}}
                </el-col>
                <el-col :span="12" class="omit">
                  <span class="bold">学历: </span>{{item.educationName}}
                </el-col>
              </el-row>
              <p class="l-30 pre-line">{{item.summary}}</p>
            </div>
            <div v-if="item.isEdit && item.id" class="p_16">
              <el-card>
                <el-form :model="item" :inline="true" label-width="80px">
                  <el-form-item label="名称">
                    <el-input v-model="item.c_schoolName"></el-input>
                  </el-form-item><br>
                  <el-form-item label="专业">
                    <el-input v-model="item.c_majorName"></el-input>
                  </el-form-item>
                  <el-form-item label="学历">
                    <el-input v-model="item.c_educationName"></el-input>
                  </el-form-item><br>
                  <el-form-item label="时间段" class="time-box">
                    <el-date-picker type="month" placeholder="选择起始时间" class="w-160" v-model="item.c_educationStartDate" value-format="yyyy-MM-dd"></el-date-picker>
                    <span class="l-40"> - </span>
                    <el-date-picker type="month" placeholder="选择结束时间" class="w-160" v-model="item.c_educationEndDate" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-form-item><br>
                  <el-form-item label="在校经历">
                    <el-input type="textarea" :rows="6" v-model="item.c_summary"></el-input>
                  </el-form-item>
                </el-form>
                <div class="center">
                  <el-button round size="medium" @click="closeBtn(item)">取消</el-button>
                  <el-button type="primary" round size="medium" @click="updateData('personEducations', item)">更新</el-button>
                </div>
              </el-card>
            </div>
          </div>
          <div class="m-t-10">
            <el-button size="medium" @click="addBtn('personEducations')" class="w1">添加 {{ tempData.personEducations.title }}</el-button>
          </div>
          <el-card class="m-t-10" v-if="personEducations.formData.isEdit">
            <el-form :model="personEducations.formData" :inline="true" label-width="80px">
              <el-form-item label="名称">
                <el-input v-model="personEducations.formData.schoolName"></el-input>
              </el-form-item><br>
              <el-form-item label="专业">
                <el-input v-model="personEducations.formData.majorName"></el-input>
              </el-form-item>
              <el-form-item label="学历">
                <el-input v-model="personEducations.formData.educationName"></el-input>
              </el-form-item><br>
              <el-form-item label="时间段" class="time-box">
                <el-date-picker type="month" placeholder="选择起始时间" class="w-160" v-model="personEducations.formData.educationStartDate" value-format="yyyy-MM-dd"></el-date-picker>
                <span class="l-40"> - </span>
                <el-date-picker type="month" placeholder="选择结束时间" class="w-160" v-model="personEducations.formData.educationEndDate" value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item><br>
              <el-form-item label="在校经历">
                <el-input type="textarea" :rows="6" v-model="personEducations.formData.summary"></el-input>
              </el-form-item>
            </el-form>
            <div class="center">
              <el-button round size="medium" @click="closeBtn(personEducations.formData)">取消</el-button>
              <el-button type="primary" round size="medium" @click="addData('personEducations')">创建</el-button>
            </div>
          </el-card>
        </el-card>
        <!-- workExperience -->
        <el-card class="t-education" v-show="resumeId">
          <p class="menu-title">{{ tempData.personWorkExperiences.title }}</p>
          <p ref="personWorkExperiences" class="menu-ref"></p>
          <div v-for="(item,index) in personWorkExperiences.list" :key="index" class="relative t-education-item">
            <p :ref="item.index" class="menu-ref"></p>
            <div v-if="!item.isEdit" @click="editBtn('personWorkExperiences', item)">
              <div class="item p-16 clearfix">
                <span class="bold i-block e-title">{{item.companyName}}</span>
                <span class="m-l-6">{{item.workStartDate|formatDate("yyyy-MM")}} - {{item.workEndDate|formatDate("yyyy-MM")}}</span>
                <el-button type="text" class="edit-btn right m-l-10">
                  <i class="el-icon-edit-outline"></i>编辑
                </el-button>
                <el-button type="text" class="edit-btn gray right" @click.stop="delBtn('personWorkExperiences', item, index)">
                  <i class="el-icon-edit-outline"></i>删除
                </el-button>
                <el-row class="l-30">
                  <el-col :span="12" class="omit">
                    <span class="bold">部门名称: </span>{{item.departmentName}}
                  </el-col>
                  <el-col :span="12" class="omit">
                    <span class="bold">岗位名称: </span>{{item.positionName}}
                  </el-col>
                </el-row>
              </div>
            </div>
            <div v-if="item.isEdit && item.id" class="p_16">
              <el-card>
                <el-form :model="item" :inline="true" label-width="80px">
                  <el-form-item label="公司名称">
                    <el-input v-model="item.c_companyName"></el-input>
                  </el-form-item><br>
                  <el-form-item label="部门名称">
                    <el-input v-model="item.c_departmentName"></el-input>
                  </el-form-item>
                  <el-form-item label="岗位名称">
                    <el-input v-model="item.c_positionName"></el-input>
                  </el-form-item><br>
                  <el-form-item label="时间段" class="time-box">
                    <el-date-picker type="month" placeholder="选择入职时间" class="w-160" v-model="item.c_workStartDate" value-format="yyyy-MM-dd"></el-date-picker>
                    <span class="l-40"> - </span>
                    <el-date-picker type="month" placeholder="选择离职时间" class="w-160" v-model="item.c_workEndDate" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-form-item><br>
                </el-form>
                <div class="center">
                  <el-button round size="medium" @click="closeBtn(item)">取消</el-button>
                  <el-button type="primary" round size="medium" @click="updateData('personWorkExperiences', item)">更新</el-button>
                </div>
              </el-card>
            </div>
            <div v-for="(ele,idx) in item.personProjectExperiences" :key="idx" class="item p-16 clearfix sub-item">
              <p :ref="ele.index" class="menu-ref"></p>
              <div v-if="!ele.isEdit" @click.stop="editBtn('personProjectExperiences', ele)">
                <span class="bold i-block e-sub-title">{{ele.projectName}}</span>
                <span class="m-l-10">{{ele.projectStartDate|formatDate("yyyy-MM")}} - {{ele.projectEndDate|formatDate("yyyy-MM")}}</span>
                <span class="m-l-10 bold">{{ele.projectRole}}</span>
                <el-button type="text" class="edit-btn right m-l-10">
                  <i class="el-icon-edit-outline"></i>编辑
                </el-button>
                <el-button type="text" class="edit-btn gray right" @click.stop="delBtn('personProjectExperiences', ele, idx, index)">
                  <i class="el-icon-edit-outline"></i>删除
                </el-button>
                <div class="m-l-16">
                  <p class="l-30 pre-line"><span class="bold top">技术框架: </span><span class="i-block entry-content">{{ele.projectSkill}}</span></p>
                  <p class="l-30 pre-line"><span class="bold top">项目概述: </span><span class="i-block entry-content">{{ele.projectSummary}}</span></p>
                  <p class="l-30 pre-line"><span class="bold top">项目职责: </span><span class="i-block entry-content">{{ele.projectDuty}}</span></p>
                </div>
              </div>
              <div v-if="ele.isEdit && ele.id" class="p_16">
                <el-card>
                  <el-form :model="ele" :inline="true" label-width="80px">
                    <el-form-item label="项目名称">
                      <el-input v-model="ele.c_projectName"></el-input>
                    </el-form-item>
                    <el-form-item label="项目角色">
                      <el-input v-model="ele.c_projectRole"></el-input>
                    </el-form-item><br>
                    <el-form-item label="技术框架" class="large">
                      <el-input type="textarea" :rows="1" v-model="ele.c_projectSkill"></el-input>
                    </el-form-item>
                    <el-form-item label="时间段" class="time-box">
                      <el-date-picker type="month" placeholder="选择项目开始时间" class="w-160" v-model="ele.c_projectStartDate" value-format="yyyy-MM-dd"></el-date-picker>
                      <span class="l-40"> - </span>
                      <el-date-picker type="month" placeholder="选择项目截止时间" class="w-160" v-model="ele.c_projectEndDate" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item><br>
                    <el-form-item label="项目职责" class="large">
                      <el-input type="textarea" :rows="3" v-model="ele.c_projectDuty"></el-input>
                    </el-form-item>
                    <el-form-item label="项目概述">
                      <el-input type="textarea" :rows="6" v-model="ele.c_projectSummary"></el-input>
                    </el-form-item>
                  </el-form>
                  <div class="center">
                    <el-button round size="medium" @click="closeBtn(ele)">取消</el-button>
                    <el-button type="primary" round size="medium" @click="updateData('personProjectExperiences', ele)">更新</el-button>
                  </div>
                </el-card>
              </div>
            </div>
            <el-button type="text" @click.stop="addProjectBtn(item)">
              <i class="el-icon-circle-plus-outline"></i>添加项目
            </el-button>
            <el-card v-if="item.isProjectEdit">
              <el-form :model="item" :inline="true" label-width="80px">
                <el-form-item label="项目名称">
                  <el-input v-model="item.projectName"></el-input>
                </el-form-item>
                <el-form-item label="项目角色">
                  <el-input v-model="item.projectRole"></el-input>
                </el-form-item><br>
                <el-form-item label="技术框架" class="large">
                  <el-input type="textarea" :rows="1" v-model="item.projectSkill"></el-input>
                </el-form-item>
                <el-form-item label="时间段" class="time-box">
                  <el-date-picker type="month" placeholder="选择项目开始时间" class="w-160" v-model="item.projectStartDate" value-format="yyyy-MM-dd"></el-date-picker>
                  <span class="l-40"> - </span>
                  <el-date-picker type="month" placeholder="选择项目截止时间" class="w-160" v-model="item.projectEndDate" value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item><br>
                <el-form-item label="项目职责" class="large">
                  <el-input type="textarea" :rows="3" v-model="item.projectDuty"></el-input>
                </el-form-item>
                <el-form-item label="项目概述">
                  <el-input type="textarea" :rows="6" v-model="item.projectSummary"></el-input>
                </el-form-item>
              </el-form>
              <div class="center">
                <el-button round size="medium" @click="closeBtn(item, 'isProjectEdit')">取消</el-button>
                <el-button type="primary" round size="medium" @click="addProjectexperience(item)">创建</el-button>
              </div>
            </el-card>
          </div>
          <div class="m-t-10">
            <el-button size="samll" @click="addBtn('personWorkExperiences')" class="w1">添加 {{ tempData.personWorkExperiences.title }}</el-button>
          </div>
          <el-card class="m-t-10" v-if="personWorkExperiences.formData.isEdit && personWorkExperiences.formData.personId">
            <el-form :model="personWorkExperiences.formData" :inline="true" label-width="80px">
              <el-form-item label="公司名称">
                <el-input v-model="personWorkExperiences.formData.companyName"></el-input>
              </el-form-item><br>
              <el-form-item label="部门名称">
                <el-input v-model="personWorkExperiences.formData.departmentName"></el-input>
              </el-form-item>
              <el-form-item label="岗位名称">
                <el-input v-model="personWorkExperiences.formData.positionName"></el-input>
              </el-form-item><br>
              <el-form-item label="时间段" class="time-box">
                <el-date-picker type="month" placeholder="选择入职时间" class="w-160" v-model="personWorkExperiences.formData.workStartDate" value-format="yyyy-MM-dd"></el-date-picker>
                <span class="l-40"> - </span>
                <el-date-picker type="month" placeholder="选择离职时间" class="w-160" v-model="personWorkExperiences.formData.workEndDate" value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item><br>
            </el-form>
            <div class="center">
              <el-button round size="medium" @click="closeBtn(personWorkExperiences.formData)">取消</el-button>
              <el-button type="primary" round size="medium" @click="addData('personWorkExperiences')">创建</el-button>
            </div>
          </el-card>
        </el-card>
        <!-- skill -->
        <el-card class="t-education b-skill" v-show="resumeId">
          <p class="menu-title">{{ tempData.personSkills.title }}</p>
          <p ref="personSkills" class="menu-ref"></p>
          <div v-for="(item,index) in personSkills.list" :key="index" class="item p-16 clearfix">
            <p :ref="item.index" class="menu-ref"></p>
            <div v-if="!item.isEdit" @click="editBtn('personSkills', item)">
              <span class="bold i-block e-title">{{item.skillTitle}}</span>
              <el-button type="text" class="edit-btn right m-l-10">
                <i class="el-icon-edit-outline"></i>编辑
              </el-button>
              <el-button type="text" class="edit-btn gray right" @click.stop="delBtn('personSkills', item, index)">
                <i class="el-icon-edit-outline"></i>删除
              </el-button>
              <br>
              <p class="l-30 pre-line">{{item.skillDetail}}</p>
            </div>
            <div v-if="item.isEdit && item.id" class="p_16">
              <el-card>
                <el-form :model="item" :inline="true" label-width="80px">
                  <el-form-item label="技能标签">
                    <el-input v-model="item.c_skillTitle"></el-input>
                  </el-form-item><br>
                  <el-form-item label="标签详情" class="large">
                    <el-input type="textarea" v-model="item.c_skillDetail"></el-input>
                  </el-form-item><br>
                </el-form>
                <div class="center">
                  <el-button round size="medium" @click="closeBtn(item)">取消</el-button>
                  <el-button type="primary" round size="medium" @click="updateData('personSkills', item)">更新</el-button>
                </div>
              </el-card>
            </div>
          </div>
          <div class="m-t-10">
            <el-button size="medium" @click="addBtn('personSkills')" class="w1">添加 {{ tempData.personSkills.title }}</el-button>
          </div>
          <el-card class="m-t-10" v-if="personSkills.formData.isEdit">
            <el-form :model="personSkills.formData" :inline="true" label-width="80px">
              <el-form-item label="技能标签">
                <el-input v-model="personSkills.formData.skillTitle"></el-input>
              </el-form-item><br>
              <el-form-item label="标签详情" class="large">
                <el-input type="textarea" v-model="personSkills.formData.skillDetail"></el-input>
              </el-form-item><br>
            </el-form>
            <div class="center">
              <el-button round size="medium" @click="closeBtn(personSkills.formData)">取消</el-button>
              <el-button type="primary" round size="medium" @click="addData('personSkills')">创建</el-button>
            </div>
          </el-card>
        </el-card>
        <!-- honor -->
        <el-card class="t-education b-honor" v-show="resumeId">
          <p class="menu-title">{{ tempData.personHonors.title }}</p>
          <p ref="personHonors" class="menu-ref"></p>
          <div v-for="(item,index) in personHonors.list" :key="index" class="item p-16 clearfix">
            <p :ref="item.index" class="menu-ref"></p>
            <div v-if="!item.isEdit" @click="editBtn('personHonors', item)">
              <span class="bold i-block e-title">{{item.honorName}}</span>
              <el-button type="text" class="edit-btn right m-l-10">
                <i class="el-icon-edit-outline"></i>编辑
              </el-button>
              <el-button type="text" class="edit-btn gray right" @click.stop="delBtn('personHonors', item, index)">
                <i class="el-icon-edit-outline"></i>删除
              </el-button>
              <br>
              <p class="l-30 pre-line">{{item.honorDetail}}</p>
            </div>
            <div v-if="item.isEdit && item.id" class="p_16">
              <el-card>
                <el-form :model="item" :inline="true" label-width="80px">
                  <el-form-item label="荣誉名称">
                    <el-input v-model="item.c_honorName"></el-input>
                  </el-form-item><br>
                  <el-form-item label="荣誉描述" class="large">
                    <el-input type="textarea" v-model="item.c_honorDetail"></el-input>
                  </el-form-item><br>
                </el-form>
                <div class="center">
                  <el-button round size="medium" @click="closeBtn(item)">取消</el-button>
                  <el-button type="primary" round size="medium" @click="updateData('personHonors', item)">更新</el-button>
                </div>
              </el-card>
            </div>
          </div>
          <div class="m-t-10">
            <el-button @click="addBtn('personHonors')" class="w1">添加 {{ tempData.personHonors.title }}</el-button>
          </div>
          <el-card class="m-t-10" v-if="personHonors.formData.isEdit">
            <el-form :model="personHonors.formData" :inline="true" label-width="80px">
              <el-form-item label="荣誉名称">
                <el-input v-model="personHonors.formData.honorName"></el-input>
              </el-form-item><br>
              <el-form-item label="荣誉描述" class="large">
                <el-input type="textarea" v-model="personHonors.formData.honorDetail"></el-input>
              </el-form-item><br>
            </el-form>
            <div class="center">
              <el-button round size="medium" @click="closeBtn(personHonors.formData)">取消</el-button>
              <el-button type="primary" round size="medium" @click="addData('personHonors')">创建</el-button>
            </div>
          </el-card>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import Head from '@/components/Head.vue';
export default {
  name: 'about',
  components: { Head },
  data() {
    return {
      isLoading: true,
      tempData: {
        'baseInfo': {
          title: '基本信息',
          index: 1
        },
        'personEducations': {
          title: '教育经历',
          addFuncName: 'addEducation',
          updateFuncName: 'updateEducation',
          deleteFuncName: 'deleteEducation',
          index: '2',
          data: ['schoolName','majorName','educationName','educationStartDate','educationEndDate','summary']
        },
        'personWorkExperiences': {
          title: '工作经验',
          addFuncName: 'addWorkexperience',
          updateFuncName: 'updateWorkexperience',
          deleteFuncName: 'deleteWorkexperience',
          index: '3',
          data: ['companyName','departmentName','positionName','workStartDate','workEndDate']
        },
        'personProjectExperiences': {
          title: '项目经验',
          addFuncName: '',
          updateFuncName: 'updateProjectexperience',
          deleteFuncName: 'deleteProjectexperience',
          index: '3',
          parent: 'personWorkExperiences',
          data: ['projectName','projectRole','projectSkill','projectStartDate','projectEndDate','projectDuty','projectSummary']
        },
        'personSkills': {
          title: '个人技能',
          addFuncName: 'addSkill',
          updateFuncName: 'updateSkill',
          deleteFuncName: 'deleteSkill',
          index: '4',
          data: ['skillTitle', 'skillDetail']
        },
        'personHonors': {
          title: '荣誉标签',
          addFuncName: 'addHonor',
          updateFuncName: 'updateHonor',
          deleteFuncName: 'deleteHonor',
          index: '5',
          data: ['honorName', 'honorDetail']
        },
        vkMap: {
          1: 'baseInfo',
          2: 'personEducations',
          3: 'personWorkExperiences',
          4: 'personSkills',
          5: 'personHonors'
        }
      },
      userId: '', //登录用户id
      resumeId: '', //区分创建、更新
      baseInfo: {
        imageUrl: '',
        isEdit: false,
        items: [
          {
            key: 'id',
            val: '',
            title: '为了接收数据',
            type: false //请求接口过滤掉 type: false数据
          }, {
            key: 'realName',
            val: '',
            title: '真实姓名',
            type: 'text'
          }, {
            key: 'sex',
            val: 1,
            title: '性别',
            type: 'radio',
            list: {
              1: {
                title: '男'
              },
              2: {
                title: '女'
              }
            }
          }, {
            key: 'wechat',
            val: '',
            title: '微信号',
            type: 'text'
          }, {
            key: 'qq',
            val: '',
            title: 'QQ',
            type: 'text'
          }, {
            key: 'email',
            val: '',
            title: '电子邮箱',
            type: 'text'
          }, {
            key: 'telephone',
            val: '',
            title: '联系方式',
            type: 'text'
          }, {
            key: 'contectAddress',
            val: '',
            title: '通信地址',
            type: 'text'
          }, {
            key: 'address',
            val: '',
            title: '家庭住址',
            type: 'text'
          }, {
            key: 'birthday',
            val: '',
            title: '生日',
            type: 'picker'
          }, {
            key: 'workBeginDate',
            val: '',
            title: '开始工作日期',
            type: 'picker'
          }, {
            key: 'positionStat',
            val: '',
            title: '当前求职状态',
            type: 'select',
            list: {
              '-1': {
                title: '请选择'
              },
              0: {
                title: '离职-随时到岗'
              },
              1: {
                title: '在职-月内到岗'
              },
              2: {
                title: '在职-考虑机会'
              },
              3: {
                title: '在职-暂不考虑'
              }
            }
          }, {
            key: 'position',
            val: '',
            title: '应聘岗位',
            type: 'text'
          }, {
            key: 'workAge',
            val: '',
            title: '工作年限',
            type: 'number'
          }, {
            key: 'educationBackground',
            val: '',
            title: '最高学历',
            type: 'select',
            list: {
              '-1': {
                title: '请选择'
              },
              0: {
                title: '其他'
              },
              1: {
                title: '专科'
              },
              2: {
                title: '本科'
              },
              3: {
                title: '硕士'
              },
              4: {
                title: '博士'
              }
            }
          }, {
            key: 'languageLevel',
            val: '',
            title: '外语等级',
            type: 'select',
            list: {
              '-1': {
                title: '请选择'
              },
              1: {
                title: 'CET-4'
              },
              2: {
                title: 'CET-6'
              }
            }
          }, {
            key: 'politicsStatus',
            val: '',
            title: '政治面貌',
            type: 'select',
            list: {
              '-1': {
                title: '请选择'
              },
              0: {
                title: '群众'
              },
              1: {
                title: '党员'
              }
            }
          }, {
            key: 'personalIntroduce',
            val: '',
            title: '个人介绍',
            type: 'textarea'
          }
        ]
      },
      personEducations: { //教育经历
        formData: {}, //操作表单
        handleIdx: 0,
        list: []
      },
      personHonors: { //荣誉标签
        formData: {}, //操作表单
        handleIdx: 0,
        list: []
      },
      personSkills: { //个人技能
        formData: {}, //操作表单
        handleIdx: 0,
        list: []
      },
      personWorkExperiences: { //工作经验
        formData: {}, //操作表单
        handleIdx: 0,
        handleSubIdx: 0,
        list: []
      }
    };
  },
  mounted() {
    let user = this.$getStorage('user') || {};
    this.userId = this.$route.query.userId;
    this.resumeId = this.$route.query.resumeId;
    if (this.userId && this.resumeId) {
      this.getBaseByIdInfo();
    } else {
      this.userId = user.userId;
      this.getBaseByUserIdInfo();
    }
  },
  methods: {
    //文件上传成功时的钩子
    handleAvatarSuccess(res, file) {
      // this.baseInfo.imageUrl = URL.createObjectURL(file.raw);
      this.baseInfo.imageUrl = res.msg;
    },

    //上传文件之前的钩子，参数为上传的文件，若返回 false 或者返回 Promise 且被 reject，则停止上传。
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isJPG = true;
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },

    handleOpen(key, keyPath) {
      this.handleAnchor(key, keyPath, 'open');
    },

    handleClose(key, keyPath) {
      this.handleAnchor(key, keyPath, 'close');
    },

    handleSelect(key, keyPath) {
      this.handleAnchor(key, keyPath, 'anchor');
    },

    handleAnchor(key, keyPath, type) {
      if (!this.resumeId) {
        this.$message({
          type: 'info',
          message: '请先保存用户基本信息！'
        });
        return false;
      }
      var firstKey = key.substr(0,1);
      var itemKey = this.tempData.vkMap[firstKey];
      setTimeout(() => {
        this.$nextTick(() => {
          if (keyPath.length == 1) {
            this.$refs[itemKey] && this.$refs[itemKey].scrollIntoView({behavior: 'smooth'});
          } else {
            this.$refs[key][0] && this.$refs[key][0].scrollIntoView({behavior: 'smooth'});
          }
        });
      }, 300);
    },

    //获取简历信息
    getBaseByIdInfo() {
      if (!this.resumeId) return false;
      var params = {
        urlPlaceholder: {
          resumeId: this.resumeId
        }
      };
      this.$get('getPersonBaseById', params)
        .then((res) => {
          this.renderData(res);
        }).catch((e) => {});
    },

    getBaseByUserIdInfo() {
      if (!this.userId) return false;
      var params = {
        urlPlaceholder: {
          userId: this.userId
        }
      };
      this.$get('getPersonBaseByUserId', params)
        .then((res) => {
          this.resumeId = res.data && res.data.id;
          this.renderData(res);
        }).catch((e) => {});
    },

    renderData(res) {
      var that = this;
      var key;
      that.baseInfo.imageUrl = res.data && res.data.imageUrl;
      that.baseInfo.items.forEach(function(ele) {
        key = ele.key;
        ele.val = res.data && res.data[key];
        if (ele.type == 'select') {
          ele.val = ele.val == undefined ? '-1' : ('' + ele.val);
        }
        if (ele.type == 'radio') {
          ele.val = '' + ele.val;
        }
      });

      ['personEducations', 'personHonors', 'personSkills', 'personWorkExperiences']
      .forEach(function(key) {
        that[key].list = res.data && res.data[key] || [];
      });

      that.personEducations.list.map((ele, idx) => {
        ele.index = '2-' + (idx + 1);
      });

      that.personWorkExperiences.list.map((element, index) => {
        element.index = '3-' + (index + 1);
        element.formData = {};
        element.personProjectExperiences.map((ele, idx) => {
          ele.index = element.index + '-' + (idx + 1);
        });
      });

      that.personSkills.list.map((ele, idx) => {
        ele.index = '4-' + (idx + 1);
      });

      that.personHonors.list.map((ele, idx) => {
        ele.index = '5-' + (idx + 1);
      });

      setTimeout(() => {
        that.isLoading = false;
      }, 500);
    },

    closeBtn(item, isProjectEdit) {
      if (item == 'baseInfo') {
        this.baseInfo = JSON.parse(JSON.stringify(this.baseInfoCopy));
        this.baseInfo.isEdit = false;
      } else if (isProjectEdit) {
        item.isProjectEdit = false;
      } else {
        item.isEdit = false;
      }
    },

    editBtn(type, item) {
      var that = this;
      let changeKey;
      if (type == 'baseInfo') {
        this.baseInfoCopy = JSON.parse(JSON.stringify(this.baseInfo));
        that.$set(that.baseInfo, 'isEdit', true);
      } else {
        that.tempData[type].data.forEach(key => {
          changeKey = 'c_' + key;
          that.$set(item, changeKey, item[key]);
        });
        that.$set(item, 'isEdit', true);
      }
    },

    delBtn(type, item, index, pIndex) {
      var that = this;
      this.$confirm('您确定要删除此内容, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var deleteFuncName = that.tempData[type].deleteFuncName;
          var params = {
            urlPlaceholder: {
              itemId: item.id
            }
          };
          that.$del(deleteFuncName, params)
            .then((res) => {
              that.$message({
                type: 'success',
                message: '删除成功!'
              });
              if (type == 'personProjectExperiences') {
                that.personWorkExperiences.list[pIndex].personProjectExperiences.splice(index, 1);
              } else {
                that[type].list.splice(index, 1);
              }
            }).catch((e) => {});
        }).catch(() => {
          that.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },

    addBtn(type) {
      this[type].formData = {
        isEdit: true,
        personId: this.resumeId
      };
    },

    addProjectBtn(item) {
      this.tempData.personProjectExperiences.data.forEach(key => {
        this.$set(item, key, '');
      });
      this.$set(item, 'isProjectEdit', true);
    },

    getParams(type, item) {
      var params = {
        id: item.id,
        personId: type == 'personProjectExperiences' ? undefined : item.personId,
        workExperienceId: type == 'personProjectExperiences' ? item.workExperienceId : undefined
      };
      let changeKey;
      this.tempData[type].data.forEach(key => {
        params[key] = item['c_' + key];
      });
      return params;
    },

    setParams(type, item) {
      let changeKey;
      this.tempData[type].data.forEach(key => {
        changeKey = 'c_' + key;
        this.$set(item, key, item[changeKey]);
      });
      this.$set(item, 'isEdit', false);
      this.$message.success('更新成功!');
    },

    handleBaseInfo() {
      if (this.resumeId) {
        this.handleBase('upd', 'put');
      } else {
        this.handleBase('add', 'post');
      }
    },

    handleBase(type, method) {
      var funcName = type + 'PersonBase';
      var that = this;
      var params = {
        id: that.resumeId,
        userId: that.userId,
        imageUrl: that.baseInfo.imageUrl || undefined
      };
      that.baseInfo.items.forEach(function(ele) {
        if (ele.type) {
          params[ele.key] = ele.val;
        }
      });
      that['$' + method](funcName, params)
        .then((res) => {
          if (type == 'add') {
            that.resumeId = res.data;
          }
          that.baseInfo.isEdit = false;
          var msg = type == 'upd' ? '更新成功!' : '保存成功!';
          that.$message.success(msg);
        }).catch((e) => {});
    },

    addData(type) {
      var that = this;
      var data = JSON.parse(JSON.stringify(that[type].formData));
      var addFuncName = that.tempData[type].addFuncName;
      var index = that.tempData[type].index;
      that.$post(addFuncName, that[type].formData)
        .then((res) => {
          if (res.data) {
            data.id = res.data;
            data.isEdit = false;
            data.index = index + '-' + (that[type].list.length + 1);
            that[type].list.push(data);
            that[type].formData = {
              isEdit: false
            };
            that.$message.success('创建成功!');
          } else {
            that.$message.success('请刷新页面哦~');
          }
        }).catch((e) => {});
    },

    updateData(type, item) {
      var that = this;
      var updateFuncName = that.tempData[type].updateFuncName;
      that.$put(updateFuncName, that.getParams(type, item))
        .then((res) => {
          that.setParams(type, item);
        }).catch((e) => {});
    },

    addWorkexperience() {
      var that = this;
      var data = that.personWorkExperiences.formData;
      that.$post('addWorkexperience', data)
        .then((res) => {
          if (res.data) {
            data.id = res.data;
            data.index = '3-' + (idx + 1);
            that.personWorkExperiences.list.push(data);
            data.isEdit = false;
            that.$message.success('创建成功!');
          } else {
            that.$message.success('请刷新页面哦~');
          }
        }).catch((e) => {});
    },

    addProjectexperience(item) {
      var that = this;
      var params = {
        workExperienceId: item.id
      };
      this.tempData.personProjectExperiences.data.forEach(key => {
        params[key] = item[key];
      });
      that.$post('addProjectexperience', params)
        .then((res) => {
          if (res.data) {
            params.id = res.data;
            params.index = item.index + '-' +item.personProjectExperiences.length + '-11';
            item.personProjectExperiences.push(params);
            that.$set(item, 'personProjectExperiences', item.personProjectExperiences);
            that.$set(item, 'isProjectEdit', false);
            that.$message.success('创建成功!');
          } else {
            that.$message.success('请刷新页面哦~');
          }
        }).catch((e) => {});
    }
  }
}
</script>
<style>
@import '~@/css/entry.css';
</style>
